var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_9106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1994 17.9852C21.0713 18.1378 21.6594 18.6158 21.6111 18.9613C21.5849 19.1458 21.0156 19.5644 20.876 19.7721C20.3277 20.5904 20.9484 21.3768 20.9621 22.1823C20.9778 23.0938 20.3887 23.9311 19.455 24L11.4028 22.3275C11.3713 22.1844 11.428 22.2311 11.4805 22.195C12.4163 21.5379 13.1704 21.1267 13.9707 20.2449C18.8511 14.8681 16.3862 6.11025 9.44309 4.15476C8.94948 4.01592 8.44957 3.97246 7.96961 3.85588C7.9108 3.84104 7.79212 3.83892 7.80577 3.75519L18.5392 0.0296971C18.7597 -0.0625127 19.0696 0.0742122 19.2166 0.244853C19.4151 0.475908 20.1702 2.49817 20.2973 2.90516C20.8098 4.5554 20.02 5.87071 20.3288 7.51671C20.6208 9.07474 23.0615 10.9391 23.825 12.5607C24.1569 13.2655 24.0078 13.6291 23.4711 14.1738C23.0121 14.6402 21.901 15.0143 21.6563 15.4383C21.1847 16.2576 22.0438 16.6593 21.9525 17.2804C21.9031 17.6153 21.5387 17.9735 21.1994 17.9841V17.9852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09871 21.197V13.9336H9.95955C10.3408 13.9336 11.1453 14.2092 11.4593 14.4434C12.7437 15.4015 12.6828 19.1461 11.7565 20.3321C11.4509 20.7243 10.6895 21.197 10.1948 21.197H7.09766H7.09871ZM8.1605 20.2441H10.0184C10.1223 20.2441 10.5666 20.0269 10.6674 19.9463C11.4582 19.3125 11.39 16.7985 11.14 15.8965C11.035 15.5192 10.8344 15.1874 10.4605 15.0348C10.3628 14.9956 9.9774 14.8854 9.90074 14.8854H8.1605V20.2431V20.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5821 10.5999H9.1604C9.19086 11.4775 9.39145 11.9449 10.3115 12.0275C10.9983 12.0901 11.7765 11.9682 12.4634 11.9099V12.743C10.2726 13.1372 8.22989 13.4277 8.0398 10.5691C7.92427 8.8267 8.59958 7.13194 10.5982 7.27397C12.4518 7.40539 12.8331 8.99628 12.5821 10.5999ZM11.5791 9.76575C11.5759 9.11287 11.5329 8.29358 10.7263 8.21514C9.50593 8.09644 9.1394 8.56173 9.1604 9.76575H11.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91259 5.48279L4.85693 6.37309C3.81194 6.35083 1.92257 5.7785 1.43421 7.05672C1.10443 7.91946 1.04142 10.7419 1.58649 11.4891C2.13156 12.2364 4.01779 11.9438 4.85588 11.7912L4.91364 12.7419C3.56724 12.9931 1.4132 13.3885 0.561462 11.9884C-0.166352 10.7917 -0.164252 7.66403 0.438584 6.41125C1.21891 4.79069 3.49057 5.2263 4.91154 5.48385L4.91259 5.48279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80007 13.9336H4.73828V21.197H5.80007V13.9336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03857 7.38672H5.91797V12.8642H7.03857V7.38672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03857 6.3749H5.91797V5.18359H6.95035L7.03857 5.27368V6.3749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_9106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCieIcon);
export default __webpack_public_path__ + "static/media/cie-icon.41f842e7d05cfdca734f4c0be5e136e2.svg";
export { ForwardRef as ReactComponent };